<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>项目版本</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form ref='queryForm' size='small' :inline='true' v-show='showSearch'>
                            <el-form-item style='margin-bottom: 0' label='项目名' prop='status'>
                                <el-select
                                    v-model='queryParams.projectAppId'
                                    placeholder='请选择项目'
                                    clearable
                                    size='mini'
                                    style='width: 240px'
                                >
                                    <el-option
                                        v-for='project in projectDataList'
                                        :key='project.label'
                                        :label='project.label'
                                        :value='project.value'
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='平台' prop='status'>
                                <el-select
                                    v-model='queryParams.channel'
                                    placeholder='请选择'
                                    clearable
                                    size='mini'
                                    style='width: 240px'
                                >
                                    <el-option
                                        v-for='item in channelList'
                                        :key='item.label'
                                        :label='item.label'
                                        :value='item.value'
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='强制更新' prop='status'>
                                <el-select
                                    v-model='queryParams.forceUpdate'
                                    placeholder='请选择'
                                    clearable
                                    size='mini'
                                    style='width: 240px'
                                >
                                    <el-option
                                        v-for='item in forceUpdateList'
                                        :key='item.label'
                                        :label='item.label'
                                        :value='item.value'
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button type='primary' icon='el-icon-search' size='mini' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4'>
                        <el-row style='float: right; margin-right: 20px' :gutter='10' class='mb8'>
                            <el-col :span='1.5'>
                                <el-button
                                    type='primary'
                                    plain
                                    icon='el-icon-plus'
                                    size='mini'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table :cell-style="{ textAlign: 'center' }" v-loading='loading' :data='distinctProjectVersionList'>
                <el-table-column label='游戏名' align='center' prop='gameName' />
                <el-table-column label='AppId' align='center' prop='appId' :show-overflow-tooltip='true' />
                <el-table-column label='平台名' align='center' prop='channel' :show-overflow-tooltip='true' />
                <el-table-column label='版本号' align='center' prop='version' :show-overflow-tooltip='true' />
                <el-table-column label='code' align='center' prop='code' :show-overflow-tooltip='true' />
                <el-table-column label='操作' align='center' class-name='small-padding fixed-width'>
                    <template slot-scope='scope'>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row, false)'
                        >修改
                        </el-button>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row, true)'
                        >修改Code
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <!--<div class='pagination'>-->
            <!--    <el-pagination-->
            <!--        :current-page='queryParams.pageNum'-->
            <!--        :page-size='queryParams.pageSize'-->
            <!--        :total='queryParams.total'-->
            <!--        background-->
            <!--        layout='prev, pager, next'-->
            <!--        @current-change='handlePagination'>-->
            <!--    </el-pagination>-->
            <!--</div>-->
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='500px' append-to-body>
                <el-alert
                    v-if='!updateStatus'
                    style='margin-bottom: .5rem;'
                    title='此处用于添加新的项目版本信息，如果只需要修改某个项目的Code值，请点击修改Code按钮'
                    type='warning'
                    :closable='false'>
                </el-alert>
                <el-form label-position='left' ref='form' :model='currentProjectVersion' label-width='100px'
                         size='mini'>
                    <el-form-item label='游戏名'>
                        <el-input size='mini' v-model='currentProjectVersion.gameName' />
                    </el-form-item>
                    <el-form-item label='所属项目'>
                        <el-select :clearable='true' filterable v-model='currentProjectVersion.projectAppId'>
                            <el-option size='mini' v-for='(item, index) in projectDataList' :key='index'
                                       :label='item.label' :value='item.value' />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if='updateStatus' label='所属游戏'>
                        <el-select :clearable='true' filterable v-model='currentProjectVersion.appId'>
                            <el-option size='mini' v-for='(item, index) in distinctAppIdAndGameNameList' :key='index'
                                       :label='item.label' :value='item.value' />
                        </el-select>
                    </el-form-item>
                    <el-form-item label='发布平台'>
                        <el-tabs v-model='tabActive'>
                            <el-tab-pane label='选择' name='chose'>
                                <el-select size='mini' :clearable='true' v-model='currentProjectVersion.channel'>
                                    <el-option v-for='(item, index) in channelList' :key='index' :label='item.label'
                                               :value='item.value' />
                                </el-select>
                            </el-tab-pane>
                            <el-tab-pane label='添加' name='add'>
                                <el-input v-model='currentProjectVersion.channel' />
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                    <el-form-item label='版本号'>
                        <el-input size='mini' v-model='currentProjectVersion.version' />
                    </el-form-item>
                    <el-form-item v-if='!updateStatus' label='Code'>
                        <el-input size='mini' v-model='currentProjectVersion.code' placeholder='请输入版本Code，默认为1'
                                  type='number' />
                    </el-form-item>
                    <el-form-item label='是否强制更新'>
                        <el-switch size='mini' :active-value='true'
                                   :inactive-value='false' v-model='currentProjectVersion.forceUpdate' />
                    </el-form-item>
                    <el-form-item label='Message'>
                        <el-input size='mini' :autosize='{ minRows: 2, maxRows: 6 }' type='textarea'
                                  v-model='currentProjectVersion.message' placeholder='强制更新message' />
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog title='版本选择' :visible.sync='multiProjectVersionOpen' width='50%' append-to-body>
                <el-table :cell-style="{ textAlign: 'center' }" v-loading='loading' :data='projectVersionList'>
                    <el-table-column label='平台名' align='center' prop='channel' :show-overflow-tooltip='true' />
                    <el-table-column label='版本号' align='center' prop='version' :show-overflow-tooltip='true' />
                    <el-table-column label='code' align='center' prop='code' :show-overflow-tooltip='true' />
                    <el-table-column label='操作' align='center' class-name='small-padding fixed-width'>
                        <template slot-scope='scope'>
                            <el-button
                                size='mini'
                                type='text'
                                icon='el-icon-edit'
                                @click='handleUpdateProjectVersion(scope.row)'
                            >修改
                            </el-button>
                            <el-button
                                icon='el-icon-delete'
                                size='mini'
                                type='text'
                                @click='handleDelete(scope.row)'
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
            
            
            <el-dialog title='修改项目Code' :visible.sync='updateCodeOpen' width='500px' append-to-body>
                <el-form ref='form' label-position='left' :model='currentProjectVersion' label-width='100px'
                         size='mini'>
                    <el-form-item label='游戏名'>
                        <p>{{ currentProjectVersion.gameName }}</p>
                    </el-form-item>
                    <el-form-item label='所属项目'>
                        <p>{{ projectInfoMap.get(currentProjectVersion.projectAppId) }}</p>
                    </el-form-item>
                    <el-form-item label='版本号'>
                        <el-input size='mini' v-model='currentProjectVersion.version' />
                    </el-form-item>
                    <el-form-item label='Code'>
                        <el-input size='mini' v-model='currentProjectVersion.code' type='number' />
                        <el-alert
                            style='margin-top: .5rem;'
                            :title='`Code值必须大于 ${originProjectVersion.code},如需回退，请点击修改，删除该版本`'
                            type='warning'
                            :closable='false'>
                        </el-alert>
                    </el-form-item>
                    <el-form-item label='是否强制更新'>
                        <el-switch size='mini' :active-value='true'
                                   :inactive-value='false' v-model='currentProjectVersion.forceUpdate' />
                    </el-form-item>
                    <el-form-item label='Message'>
                        <el-input size='mini' :autosize='{ minRows: 2, maxRows: 6 }' type='textarea'
                                  v-model='currentProjectVersion.message' placeholder='强制更新message' />
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='handleUpdateCode'>确 定</el-button>
                    <el-button @click='updateCodeOpen = false'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import upload from '@/components/page/projects/Upload.vue';
import { deepCopy } from '@/utils/object';
import {
    deleteProjectVersionById,
    insertProjectVersion,
    queryAllChannel,
    queryDistinctAppIdAndGameName,
    queryDistinctProjectVersionList,
    queryProjectVersionList,
    updateProjectVersionById,
    updateProjectVersionCode
} from '@/components/api/ProjectVersion';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';

export default {
    name: 'Dict',
    computed: {
        upload() {
            return upload;
        }
    },
    data() {
        return {
            tabActive: 'add',
            // 遮罩层
            loading: true,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            updateCodeOpen: false,
            multiProjectVersionOpen: false,
            // 查询参数
            queryParams: {
                total: 1,
                pageNum: 1,
                pageSize: 15,
                channel: undefined,
                forceUpdate: undefined,
                projectAppId: undefined
            },
            updateStatus: false,
            // 所有项目
            projectDataList: [],
            channelList: [],
            distinctProjectVersionList: [],
            forceUpdateList: [
                {
                    label: '强制更新',
                    value: true
                },
                {
                    label: '不强制更新',
                    value: false
                }
            ],
            currentProjectVersion: {},
            distinctAppIdAndGameNameList: [],
            originProjectVersion: {},
            projectVersionList: [],
            projectInfoMap: new Map
        };
    },
    created() {
        this.getList();
    },
    methods: {
        init() {
            this.projectVersionList = [];
            this.projectDataList = [];
            this.channelList = [];
            this.distinctAppIdAndGameNameList = [];
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.init();
            this.loading = true;
            
            queryDistinctProjectVersionList(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.distinctProjectVersionList = result.data;
                    this.loading = false;
                }
            });
            
            queryProjectInfoList({ pageNum: 1, pageSize: 100000 }).then(result => {
                if (result.code === 200) {
                    result.data.result.forEach(project => {
                        this.projectDataList.push({
                            label: project.cnName,
                            value: project.appId
                        });
                        this.projectInfoMap.set(project.appId, project.cnName);
                    });
                }
            });
            
            queryAllChannel().then(result => {
                if (result.code === 200) {
                    result.data.forEach(value => {
                        this.channelList.push({
                            label: value,
                            value: value
                        });
                    });
                }
            });
            queryDistinctAppIdAndGameName().then(result => {
                if (result.code === 200) {
                    result.data.forEach(data => {
                        this.distinctAppIdAndGameNameList.push({
                            label: data.gameName,
                            value: data.appId
                        });
                    });
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '添加数据';
            this.updateStatus = false;
            this.currentProjectVersion = {};
        },
        /** 修改按钮操作 */
        handleUpdate(row, updateCode) {
            if (!updateCode) {
                this.multiProjectVersionOpen = true;
                this.title = '修改项目版本信息';
                this.updateStatus = true;
                this.queryProjectVersionByAppId(row.appId);
            } else {
                this.updateCodeOpen = true;
                this.currentProjectVersion = deepCopy(row);
                this.originProjectVersion = deepCopy(row);
            }
        },
        handleUpdateProjectVersion(row) {
            this.open = true;
            this.title = '修改项目版本信息';
            this.updateStatus = true;
            this.currentProjectVersion = deepCopy(row);
            this.originProjectVersion = deepCopy(row);
        },
        queryProjectVersionByAppId(appId) {
            queryProjectVersionList({ appId: appId }).then(result => {
                if (result.code === 200) {
                    this.projectVersionList = result.data;
                }
            });
        },
        handleDelete(row) {
            let obj = this;
            let msg = '';
            if (row.gameName) {
                msg = row.gameName;
            }
            if (row.version) {
                msg = msg + ' ' + row.version;
            }
            this.$modal.confirm('是否确定删除"' + msg + '"的数据项？').then(function() {
                return deleteProjectVersionById(row);
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    obj.$modal.msgSuccess('删除成功');
                    obj.queryProjectVersionByAppId(row.appId);
                }
            });
        },
        handleUpdateCode() {
            updateProjectVersionCode(this.currentProjectVersion).then(result => {
                if (result.code === 200) {
                    message.success('修改成功');
                    this.updateCodeOpen = false;
                    this.multiProjectVersionOpen = false;
                    this.getList();
                }
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                updateProjectVersionById(this.currentProjectVersion).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.open = false;
                        this.getList();
                        this.multiProjectVersionOpen = false;
                    }
                });
            } else {
                insertProjectVersion(this.currentProjectVersion).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        }
    }
};
</script>
<style lang='css'>

</style>